import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "google-maps",
  "use": "google-maps-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"google-maps\">\n    <path fill=\"#000\" style=\"fill: var(--color1, #000)\" d=\"M15.751 9.6c-2.811 0-5.084 2.17-5.084 4.853 0 3.64 5.084 9.013 5.084 9.013s5.084-5.373 5.084-9.013c0-2.683-2.273-4.853-5.084-4.853zM15.751 16.187c-1.002 0-1.816-0.777-1.816-1.733s0.813-1.733 1.816-1.733c1.002 0 1.816 0.777 1.816 1.733s-0.814 1.733-1.816 1.733z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol